var $ad129f032a0e1d8e$exports = {};
const $ad129f032a0e1d8e$var$account1 = {
    owner: "Jonas Schmedtmann",
    movements: [
        200,
        455.23,
        -306.5,
        25000,
        -642.21,
        -133.9,
        79.97,
        1300
    ],
    interestRate: 1.2,
    pin: 1111,
    movementsDates: [
        "2019-11-18T21:31:17.178Z",
        "2019-12-23T07:42:02.383Z",
        "2020-01-28T09:15:04.904Z",
        "2020-04-01T10:17:24.185Z",
        "2020-05-08T14:11:59.604Z",
        "2020-05-27T17:01:17.194Z",
        "2023-08-26T12:01:20.894Z",
        "2023-08-28T12:01:20.894Z"
    ],
    currency: "EUR",
    locale: "pt-PT"
};
const $ad129f032a0e1d8e$var$account2 = {
    owner: "Jessica Davis",
    movements: [
        5000,
        3400,
        -150,
        -790,
        -3210,
        -1000,
        8500,
        -30
    ],
    interestRate: 1.5,
    pin: 2222,
    movementsDates: [
        "2019-11-01T13:15:33.035Z",
        "2019-11-30T09:48:16.867Z",
        "2019-12-25T06:04:23.907Z",
        "2020-01-25T14:18:46.235Z",
        "2020-02-05T16:33:06.386Z",
        "2020-04-10T14:43:26.374Z",
        "2023-08-26T12:01:20.894Z",
        "2023-08-28T12:01:20.894Z"
    ],
    currency: "USD",
    locale: "en-US"
};
const $ad129f032a0e1d8e$var$accounts = [
    $ad129f032a0e1d8e$var$account1,
    $ad129f032a0e1d8e$var$account2
];
/////////////////////////////////////////////////
// Elements
const $ad129f032a0e1d8e$var$labelWelcome = document.querySelector(".welcome");
const $ad129f032a0e1d8e$var$labelDate = document.querySelector(".date");
const $ad129f032a0e1d8e$var$labelBalance = document.querySelector(".balance__value");
const $ad129f032a0e1d8e$var$labelSumIn = document.querySelector(".summary__value--in");
const $ad129f032a0e1d8e$var$labelSumOut = document.querySelector(".summary__value--out");
const $ad129f032a0e1d8e$var$labelSumInterest = document.querySelector(".summary__value--interest");
const $ad129f032a0e1d8e$var$labelTimer = document.querySelector(".timer");
const $ad129f032a0e1d8e$var$containerApp = document.querySelector(".app");
const $ad129f032a0e1d8e$var$containerMovements = document.querySelector(".movements");
const $ad129f032a0e1d8e$var$btnLogin = document.querySelector(".login__btn");
const $ad129f032a0e1d8e$var$btnTransfer = document.querySelector(".form__btn--transfer");
const $ad129f032a0e1d8e$var$btnLoan = document.querySelector(".form__btn--loan");
const $ad129f032a0e1d8e$var$btnClose = document.querySelector(".form__btn--close");
const $ad129f032a0e1d8e$var$btnSort = document.querySelector(".btn--sort");
const $ad129f032a0e1d8e$var$inputLoginUsername = document.querySelector(".login__input--user");
const $ad129f032a0e1d8e$var$inputLoginPin = document.querySelector(".login__input--pin");
const $ad129f032a0e1d8e$var$inputTransferTo = document.querySelector(".form__input--to");
const $ad129f032a0e1d8e$var$inputTransferAmount = document.querySelector(".form__input--amount");
const $ad129f032a0e1d8e$var$inputLoanAmount = document.querySelector(".form__input--loan-amount");
const $ad129f032a0e1d8e$var$inputCloseUsername = document.querySelector(".form__input--user");
const $ad129f032a0e1d8e$var$inputClosePin = document.querySelector(".form__input--pin");
/////////////////////////////////////////////////
// Functions
const $ad129f032a0e1d8e$var$formatMovementDate = function(date, locale) {
    const calcDaysPassed = (date1, date2)=>Math.round(Math.abs(date2 - date1) / 86400000);
    const daysPassed = calcDaysPassed(new Date(), date);
    if (daysPassed === 0) return "Today";
    if (daysPassed === 1) return "Yesterday";
    if (daysPassed <= 7) return `${daysPassed} days ago`;
    // Debugging
    console.log(`Formatting date: ${date} for locale: ${locale}`);
    return new Intl.DateTimeFormat(locale).format(date);
};
// generic currency formatter
const $ad129f032a0e1d8e$var$formatCur = function(value, locale, currency) {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    }).format(value);
};
const $ad129f032a0e1d8e$var$displayMovements = function(acc, sort = false) {
    console.log("Displaying movements");
    $ad129f032a0e1d8e$var$containerMovements.innerHTML = "";
    const movs = sort ? acc.movements.slice().sort((a, b)=>a - b) : acc.movements;
    movs.forEach(function(mov, i) {
        const type = mov > 0 ? "deposit" : "withdrawal";
        const date = new Date(acc.movementsDates[i]); // use current index to loop over other array (common technique)
        const displayDate = $ad129f032a0e1d8e$var$formatMovementDate(date, acc.locale);
        const formattedMov = $ad129f032a0e1d8e$var$formatCur(mov, acc.locale, acc.currency);
        // Debugging
        console.log(`Movement: ${mov}, Date: ${date}, Display Date: ${displayDate}`);
        const html = `
      <div class="movements__row">
        <div class="movements__type movements__type--${type}">${i + 1} ${type}</div>
        <div class="movements__date">${displayDate}</div>
        <div class="movements__value">${formattedMov}</div>
      </div>
    `;
        $ad129f032a0e1d8e$var$containerMovements.insertAdjacentHTML("afterbegin", html);
    });
};
const $ad129f032a0e1d8e$var$calcDisplayBalance = function(acc) {
    acc.balance = acc.movements.reduce((acc, mov)=>acc + mov, 0);
    $ad129f032a0e1d8e$var$labelBalance.textContent = $ad129f032a0e1d8e$var$formatCur(acc.balance, acc.locale, acc.currency);
};
const $ad129f032a0e1d8e$var$calcDisplaySummary = function(acc) {
    const incomes = acc.movements.filter((mov)=>mov > 0).reduce((acc, mov)=>acc + mov, 0);
    $ad129f032a0e1d8e$var$labelSumIn.textContent = $ad129f032a0e1d8e$var$formatCur(incomes, acc.locale, acc.currency);
    const out = acc.movements.filter((mov)=>mov < 0).reduce((acc, mov)=>acc + mov, 0);
    $ad129f032a0e1d8e$var$labelSumOut.textContent = $ad129f032a0e1d8e$var$formatCur(Math.abs(out), acc.locale, acc.currency);
    const interest = acc.movements.filter((mov)=>mov > 0).map((deposit)=>deposit * acc.interestRate / 100).filter((int, i, arr)=>{
        // console.log(arr);
        return int >= 1;
    }).reduce((acc, int)=>acc + int, 0);
    $ad129f032a0e1d8e$var$labelSumInterest.textContent = $ad129f032a0e1d8e$var$formatCur(interest, acc.locale, acc.currency);
};
const $ad129f032a0e1d8e$var$createUsernames = function(accs) {
    accs.forEach(function(acc) {
        acc.username = acc.owner.toLowerCase().split(" ").map((name)=>name[0]).join("");
    });
};
$ad129f032a0e1d8e$var$createUsernames($ad129f032a0e1d8e$var$accounts);
const $ad129f032a0e1d8e$var$updateUI = function(acc) {
    // Display movements
    $ad129f032a0e1d8e$var$displayMovements(acc);
    // Display balance
    $ad129f032a0e1d8e$var$calcDisplayBalance(acc);
    // Display summary
    $ad129f032a0e1d8e$var$calcDisplaySummary(acc);
};
const $ad129f032a0e1d8e$var$startLogOutTimer = function() {
    const tick = function() {
        const min = String(Math.trunc(time / 60)).padStart(2, 0);
        const sec = String(time % 60).padStart(2, 0);
        // Each callback call, print the remaining time to UI
        $ad129f032a0e1d8e$var$labelTimer.textContent = `${min}:${sec}`;
        // When 0 sec stop timer and log out user.
        if (time === 0) {
            clearInterval(timer);
            $ad129f032a0e1d8e$var$containerApp.style.opacity = 0;
            $ad129f032a0e1d8e$var$labelWelcome.textContent = `Log in to get started`;
        }
        // Decrease time
        time--;
    };
    // Set time to 5 mins
    let time = 120;
    // Call the timer every second
    tick();
    const timer = setInterval(tick, 1000);
    return timer; // we need this variable to be able to stop timer
};
///////////////////////////////////////
// Event handlers
let $ad129f032a0e1d8e$var$currentAccount, $ad129f032a0e1d8e$var$timer;
$ad129f032a0e1d8e$var$btnLogin.addEventListener("click", function(e) {
    console.log("Login button clicked");
    // Prevent form from submitting
    e.preventDefault();
    $ad129f032a0e1d8e$var$currentAccount = $ad129f032a0e1d8e$var$accounts.find((acc)=>acc.username === $ad129f032a0e1d8e$var$inputLoginUsername.value);
    if ($ad129f032a0e1d8e$var$currentAccount?.pin === +$ad129f032a0e1d8e$var$inputLoginPin.value) {
        // Display UI and message
        $ad129f032a0e1d8e$var$labelWelcome.textContent = `Welcome back, ${$ad129f032a0e1d8e$var$currentAccount.owner.split(" ")[0]}`;
        $ad129f032a0e1d8e$var$containerApp.style.opacity = 100;
        const now = new Date();
        const options = {
            hour: "numeric",
            minute: "numeric",
            day: "numeric",
            month: "numeric",
            year: "numeric"
        };
        // const locale = navigator.language;
        $ad129f032a0e1d8e$var$labelDate.textContent = new Intl.DateTimeFormat($ad129f032a0e1d8e$var$currentAccount.locale, options).format(now); // creates new formatter to which we call .format()
        // Clear input fields
        $ad129f032a0e1d8e$var$inputLoginUsername.value = $ad129f032a0e1d8e$var$inputLoginPin.value = "";
        $ad129f032a0e1d8e$var$inputLoginPin.blur();
        // Timer
        if ($ad129f032a0e1d8e$var$timer) clearInterval($ad129f032a0e1d8e$var$timer);
        $ad129f032a0e1d8e$var$timer = $ad129f032a0e1d8e$var$startLogOutTimer();
        // Update UI
        $ad129f032a0e1d8e$var$updateUI($ad129f032a0e1d8e$var$currentAccount);
    }
});
$ad129f032a0e1d8e$var$btnTransfer.addEventListener("click", function(e) {
    e.preventDefault();
    const amount = +$ad129f032a0e1d8e$var$inputTransferAmount.value;
    const receiverAcc = $ad129f032a0e1d8e$var$accounts.find((acc)=>acc.username === $ad129f032a0e1d8e$var$inputTransferTo.value);
    $ad129f032a0e1d8e$var$inputTransferAmount.value = $ad129f032a0e1d8e$var$inputTransferTo.value = "";
    if (amount > 0 && receiverAcc && $ad129f032a0e1d8e$var$currentAccount.balance >= amount && receiverAcc?.username !== $ad129f032a0e1d8e$var$currentAccount.username) {
        // Doing the transfer
        $ad129f032a0e1d8e$var$currentAccount.movements.push(-amount);
        receiverAcc.movements.push(amount);
        // Add transfer date
        $ad129f032a0e1d8e$var$currentAccount.movementsDates.push(new Date().toISOString());
        receiverAcc.movementsDates.push(new Date().toISOString());
        // Update UI
        $ad129f032a0e1d8e$var$updateUI($ad129f032a0e1d8e$var$currentAccount);
        // Reset timer
        clearInterval($ad129f032a0e1d8e$var$timer);
        $ad129f032a0e1d8e$var$timer = $ad129f032a0e1d8e$var$startLogOutTimer();
    }
});
$ad129f032a0e1d8e$var$btnLoan.addEventListener("click", function(e) {
    e.preventDefault();
    const amount = Math.floor($ad129f032a0e1d8e$var$inputLoanAmount.value);
    if (amount > 0 && $ad129f032a0e1d8e$var$currentAccount.movements.some((mov)=>mov >= amount * 0.1)) setTimeout(function() {
        // Add movement
        $ad129f032a0e1d8e$var$currentAccount.movements.push(amount);
        // Add loan date
        $ad129f032a0e1d8e$var$currentAccount.movementsDates.push(new Date().toISOString());
        // Update UI
        $ad129f032a0e1d8e$var$updateUI($ad129f032a0e1d8e$var$currentAccount);
        // Reset timer
        clearInterval($ad129f032a0e1d8e$var$timer);
        $ad129f032a0e1d8e$var$timer = $ad129f032a0e1d8e$var$startLogOutTimer();
    }, 2500);
    $ad129f032a0e1d8e$var$inputLoanAmount.value = "";
});
$ad129f032a0e1d8e$var$btnClose.addEventListener("click", function(e) {
    e.preventDefault();
    if ($ad129f032a0e1d8e$var$inputCloseUsername.value === $ad129f032a0e1d8e$var$currentAccount.username && +$ad129f032a0e1d8e$var$inputClosePin.value === $ad129f032a0e1d8e$var$currentAccount.pin) {
        const index = $ad129f032a0e1d8e$var$accounts.findIndex((acc)=>acc.username === $ad129f032a0e1d8e$var$currentAccount.username);
        // Delete account
        $ad129f032a0e1d8e$var$accounts.splice(index, 1);
        // Hide UI
        $ad129f032a0e1d8e$var$containerApp.style.opacity = 0;
    }
    $ad129f032a0e1d8e$var$inputCloseUsername.value = $ad129f032a0e1d8e$var$inputClosePin.value = "";
});
let $ad129f032a0e1d8e$var$sorted = false;
$ad129f032a0e1d8e$var$btnSort.addEventListener("click", function(e) {
    e.preventDefault();
    $ad129f032a0e1d8e$var$displayMovements($ad129f032a0e1d8e$var$currentAccount, !$ad129f032a0e1d8e$var$sorted);
    $ad129f032a0e1d8e$var$sorted = !$ad129f032a0e1d8e$var$sorted;
});


//# sourceMappingURL=login.5fd9d5bc.js.map
